__turbopack_context__.v({
  "className": "graphikitalic_582c69ad-module__WbCy0a__className",
  "variable": "graphikitalic_582c69ad-module__WbCy0a__variable",
});
